import { IParentMessageData } from '../redux/parentDataSlice';

export const initializeReactGA = async (url: string, dataFromParent: IParentMessageData) => {
  if (!dataFromParent) return;
  const prodEnvUrl = window.location.href;
  const { trackingId, userId } = dataFromParent;

  //ga works only on production
  if (prodEnvUrl.includes('loree-int.crystaldelta.net')) {
    let gaScript = document.getElementById('script');
    let gaFunction = document.getElementById('scriptText');

    if (gaScript && (gaScript !== null || gaScript !== undefined)) {
      gaScript.remove();
      gaFunction?.remove();
    }

    if (!trackingId) return;
    const googleAnalyticsScript = document.createElement('script');
    googleAnalyticsScript.async = true;
    googleAnalyticsScript.id = 'script';
    googleAnalyticsScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    const gaFunctionScript = document.createElement('script');
    gaFunctionScript.id = 'scriptText';
    const innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', '${trackingId}', {'page_path': '${url}', 'user_id': '${userId}',  'cookie_prefix': 'gaCookie','cookie_domain': 'auto', 'cookie_expires': 60 * 60 * 24 * 28, 'cookie_update': 'true'});gtag('set', {'cookie_flags': 'SameSite=None;Secure'});`;
    gaFunctionScript.innerText = innerText;

    document.body.appendChild(googleAnalyticsScript);
    document.body.appendChild(gaFunctionScript);
  }
};
